import React from 'react';
import type { PositionLabel } from '../../lib/pricePosition';

const TONES: Record<PositionLabel['tone'], string> = {
  lowest: 'bg-emerald-500/10 border-emerald-500/20 text-emerald-400',
  mixed: 'bg-amber-500/10 border-amber-500/20 text-amber-400',
  not_lowest: 'bg-amber-500/10 border-amber-500/20 text-amber-400',
};

const HINT =
  "Compared with other suppliers' in-stock offers for the same style code and size. Their prices and names are never shown.";

const PricePositionBadge: React.FC<{ label: PositionLabel | null }> = ({ label }) => {
  if (!label) return null;
  return (
    <span
      title={HINT}
      className={`inline-flex items-center px-1.5 py-0.5 rounded text-[10px] font-semibold border whitespace-nowrap ${TONES[label.tone]}`}
    >
      {label.text}
    </span>
  );
};

export default PricePositionBadge;
